module.exports = __webpack_public_path__ + "media/images/sp/stores/nagoya_ekimae/nagoya_ekimae_sns_04-31e856ecdff31887f8d6c7c9f0c74582.jpg";